import { render, staticRenderFns } from "./MonthComparisons.vue?vue&type=template&id=20391dfe"
import script from "./MonthComparisons.vue?vue&type=script&lang=js"
export * from "./MonthComparisons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports